var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415,0H75c-5.523,0-10,4.477-10,10v470c0,5.522,4.477,10,10,10h40c5.523,0,10-4.478,10-10V270h290c5.523,0,10-4.478,10-10 V10C425,4.477,420.523,0,415,0z M105,470H85V20h20V470z M175,250h-50v-45h50V250z M175,185h-50v-40h50V185z M175,125h-50V85h50 V125z M175,65h-50V20h50V65z M255,250h-60v-45h60V250z M255,185h-60v-40h60V185z M255,125h-60V85h60V125z M255,65h-60V20h60V65z  M335,250h-60v-45h60V250z M335,185h-60v-40h60V185z M335,125h-60V85h60V125z M335,65h-60V20h60V65z M405,250h-50v-45h50V250z  M405,185h-50v-40h50V185z M405,125h-50V85h50V125z M405,65h-50V20h50V65z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSvgrepoCom);
export default __webpack_public_path__ + "static/media/flag-svgrepo-com.61c43cbb643816896b1c8ad810f32690.svg";
export { ForwardRef as ReactComponent };